import React from "react";

/**
 * Shape of a Hall ad's deserialized `components` payload.
 *
 * `components` is stored as a JSON string on the ad record; the Átrio list and
 * the Hall editor both deserialize it at render time.
 */
export type HallAdGeneralComponent = {
  // Kept loose (`unknown[]`) on purpose: the parser only guarantees that
  // `components` is an array. Callers cast to their richer component type.
  components: any[];
  background: React.CSSProperties;
};

/**
 * Safely parse the serialized `components` payload of a Hall ad.
 *
 * A single malformed string must NOT crash the whole Átrio list (or the
 * editor), so this returns `null` — letting callers skip / placeholder the bad
 * row — instead of throwing inside render.
 */
export function parseHallAdComponents(raw: string | undefined): HallAdGeneralComponent | null {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (!parsed || !Array.isArray(parsed.components)) return null;
    return parsed as HallAdGeneralComponent;
  } catch {
    return null;
  }
}
